import { useEffect } from 'react';

function CalendlyWidget() {
    useEffect(() => {
        const scriptExists = document.querySelector('script[src="https://assets.calendly.com/assets/external/widget.js"]');
        if (!scriptExists) {
            const script = document.createElement("script");
            script.src = "https://assets.calendly.com/assets/external/widget.js";
            script.async = true;
            document.body.appendChild(script);
        }
    }, []);

    return (
        <div
            className="calendly-inline-widget"
            data-url="https://calendly.com/fmtestingaddress"
            style={{ minWidth: '320px', height: '700px' }}
        ></div>
    );
}

export default CalendlyWidget;
